import scrollList from './scrollLoadList.vue'
export default {
  name: "zones-check",
  components:{scrollList},
  props:{
    value:{
      type: Object,
      default(){
        return {
          dcsAccessZoneIds: [],
          startDCSAutoZoneId: null,
          endDCSAutoZoneId: null,
          dcsProfileId:null,
          disNodeIds:[],
          isMandatory:false,
          allZoneList:[],
          zoneList:[],
        }
      }
    },
    editFlag:{ /*是否为编辑状态, 编辑状态下不自动填充end Zone*/
      type:Boolean,
      default:false
    },
    // 启用节点选择
    enableSelectNode:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      zoneList: [], //access zone的zone列表
      startDCSAutoZoneId: null,
      profileList:[], //profile 列表
      checkAll: 0,
      searchTimer:'',
      panelShrink:'',
      dcsModal:false,
      editDcsInfo:{},
      defaultZoneIds: [],
      checkAllDcs: false,
      specialZoneList: [] , //特殊楼层
      autoFill:false,
      noStartZone:[],
      noEndZone:[],
      oldValue:null
    }
  },
  watch:{
    data:{
      handler(nv, ov){
        this.initData();
      },
      deep: true
    }
  },
  computed: {
    checkedDcsZones(){
      let output = [];
      let dcsZoneIds = this.value.dcsAccessZoneIds;
      if( !dcsZoneIds ){
        output = [];
      }else{
        output = this.value.allZoneList.filter((zone)=>{
          return dcsZoneIds.indexOf(zone.id) > -1;
        });
      }
      return output;
    }, 
    
    // auto zone的可选项
    autoStartZoneList(){
      if(!this.value.allZoneList){
        return []
      }
      let selDcsAccessZoneIds = this.value.dcsAccessZoneIds;
      let startList = this.value.allZoneList.filter((zone)=>{
        return selDcsAccessZoneIds.indexOf(zone.id) > -1 && this.noStartZone.indexOf(zone.id) == -1 && !zone.isVirtual;
      })
      return startList;
      },
    autoEndZoneList(){
      if(!this.value.allZoneList){
        return []
      }
    let selDcsAccessZoneIds = this.value.dcsAccessZoneIds;
    let endList = this.value.allZoneList.filter((zone)=>{
      return selDcsAccessZoneIds.indexOf(zone.id) > -1 && this.noEndZone.indexOf(zone.id) == -1 && !zone.isVirtual;
    })
    return endList;
    },
  },
  mounted(){
    let _this = this;
    $(document).bind('click', this.panelShrink = function(e) {
      // 关闭tag选泽
      if(!((e.target.className.indexOf('dcs-check-btn') > -1) || $(e.target).parents('.dcs-check-btn').length > 0)){
        $('.dcs-panel-box').slideUp(300);
      }
    });
    if (!this.enableSelectNode || this.value.targetNodeId) {
      this.getDCSZoneList();
      this.getProfileList();
    }
    if(!this.oldValue && this.value.targetNodeId){
      this.oldValue = JSON.parse(JSON.stringify(this.value))
    }
    _this.initData();
  },
  beforeDestroy(){
    $(document).unbind('click', this.panelShrink);
  },
  methods:{
    initData: function(){
      let value = JSON.parse( JSON.stringify( this.value ));
      // 新增状态下获取配置项的值，默认为新增状态
      if(!this.editFlag && !value.endDCSAutoZoneId && !value.startDCSAutoZoneId){
        value.startDCSAutoZoneId = window.g.dcsAutoZone.startDCSAutoZoneId;
        value.endDCSAutoZoneId = window.g.dcsAutoZone.endDCSAutoZoneId;
      }
      if( value.startDCSAutoZoneId === null ){
        this.startDCSAutoZoneId = 'all';
      }else{
        this.startDCSAutoZoneId = value.startDCSAutoZoneId;
      }
      if (this.value.targetNodeId) {
        this.$ajax.get('SystemSetting/GetNodeSettings?queryNodeId=' + this.value.targetNodeId).then(res=>{
          if(res.data.success){
            this.value.isMandatory = res.data.data['system.setting.node.user.dcszone.required'];
            this.noStartZone = res.data.data['system.setting.node.nonselectabledcszone.nonselectable.start.zones'];
            this.noEndZone = res.data.data['system.setting.node.nonselectabledcszone.nonselectable.end.zones'];
            this.autoFill = res.data.data['system.setting.node.nonselectabledcszone.auto.fill'];
          }
        });
      }
    },
    
    // 打开tag添加面板
    openTagPanel:function (e) {
      $(e.target).parents('.dcs-zone-check').find('.dcs-panel-box').slideDown(300);
    },
    // 选择节点
    handleNodeChange: function(data){
      if(!data){
        return false;
      }
      let _this = this;
      this.clearValue();
      this.getDCSZoneList();
      this.getProfileList();
      this.$ajax.get('SystemSetting/GetNodeSettings?queryNodeId=' + this.value.targetNodeId).then(res=>{
        if(res.data.success){
          this.value.isMandatory = res.data.data['system.setting.node.user.dcszone.required'];
          if(!this.value.isMandatory){    
            if(_this.$parent.$parent.$parent.dCSFlag){
              _this.$parent.$parent.$parent.dCSFlag = false;
            }else{
              _this.$parent.$parent.dCSFlag = false;
            }
          }
          this.noStartZone = res.data.data['system.setting.node.nonselectabledcszone.nonselectable.start.zones'];
          this.noEndZone = res.data.data['system.setting.node.nonselectabledcszone.nonselectable.end.zones'];
          this.autoFill = res.data.data['system.setting.node.nonselectabledcszone.auto.fill'];
          if(this.oldValue && this.oldValue.targetNodeId && this.oldValue.targetNodeId == data.id){
            this.oldValue.isMandatory = this.value.isMandatory;
            this.updateValue(JSON.parse(JSON.stringify(this.oldValue)));
          }
        }
      })
    },
    //获取profileList
    getProfileList:function(){
      let params =  {enabledPaging:false,sortName:"displayName",sortType:0};
      if (this.value.targetNodeId) {
        params.queryNodeId = this.value.targetNodeId;
      }
      this.$ajax.post('DCSProfile/Paging',params).then(res=> {
        if(res.data.success){
          this.profileList = res.data.data.items;
        }else {
          this.profileList = [];
        }
      });
    },
    // 查询DCS Zone
    getDCSZoneList: function () {
      let _this = this;
      _this.zoneList = [];
      _this.specialZoneList = [];
      _this.value.allZoneList = [];
      _this.defaultZoneIds = [];
      clearTimeout(this.searchTimer);
      let searchParams = {};
      if (this.value.targetNodeId) {
        searchParams.queryNodeId = this.value.targetNodeId;
      }
      this.searchTimer = setTimeout(()=>{
        this.$ajax.post('DCSZone/QueryOption', searchParams,{headers:{noLoading:true}}).then((res)=> {
          if (res.data.success) {
            _this.value.allZoneList = JSON.parse(JSON.stringify(res.data.data));
            res.data.data.forEach(val => {
              if(val.isEnableSpecial) {
                if (val.isSpecial) {
                  _this.specialZoneList.push(val);
                } else {
                  if (val.isDefault) {
                      _this.defaultZoneIds.push(val.id);
                  }
                  _this.zoneList.push(val);
                    // 将默认楼层返回给上一级，用来做部门改变的判断
                  let value = JSON.parse(JSON.stringify(_this.value));
                  _this.$set(value,'defaultZoneIds',_this.defaultZoneIds)
                  this.updateValue(value);
                }
              }else {
                _this.zoneList.push(val);
              }
            });
          } else {
            this.messageNotice("error",res.data.message);
          }
          this.quickEditDcs()
        })
      }, 300);
    },
    // 点击选All
    clickAllCheck: function(){
      let valueObj = JSON.parse( JSON.stringify( this.value ));
      let selZoneIds = valueObj.dcsAccessZoneIds;
      // 全选
      if( this.checkAll === 0 ){
        this.zoneList.forEach((item)=>{
          if( selZoneIds.indexOf( item.id ) === -1 ){
            selZoneIds.push( item.id );
          }
        })
        // 如果没有end auto zone, 选择第一个
        if( selZoneIds.length ){
          this.autoAddDCSEndAutoZone(valueObj, selZoneIds[0]);
        }
        this.checkAll = 2;
      }else{
        // 取消所有选择
        this.zoneList.forEach((item)=>{
          selZoneIds = selZoneIds.filter((childId)=>{
            // 同步删除auto zone中对应的zone
            this.autoDeleteDCSAutoZone(valueObj, childId);
            return childId !== item.id;
          })
        })
        this.checkAll = 0;
      }
      valueObj.dcsAccessZoneIds = selZoneIds;
      this.updateValue(valueObj);
    },
    // 处理start auto zone的值
    handleBeginZone: function(val){
      let _this = this;
      let value = this.value;
      if( val === 'all' ){
        value.startDCSAutoZoneId = null;
      }else{
        value.startDCSAutoZoneId = val;
      }
      this.updateValue(value);
      if(this.value.startDCSAutoZoneId && this.value.startDCSAutoZoneId.length){
        _this.$parent.dCSFlag = false;
        _this.$parent.$parent.dCSFlag = false;
        _this.$parent.$parent.$parent.dCSFlag = false;
      }
    },
    handleEndZone:function(){
      let _this = this;
      _this.$parent.dCSFlag = false;
      _this.$parent.$parent.dCSFlag = false;
      _this.$parent.$parent.$parent.dCSFlag = false;
    },
    clearValue: function(){
      let _this = this;
      let value = JSON.parse( JSON.stringify( this.value ) );
      value.dcsAccessZoneIds = [];
      value.startDCSAutoZoneId = null;
      value.endDCSAutoZoneId = null;
      value.dcsProfileId = null;
      this.startDCSAutoZoneId = 'all';
      this.checkAll = 0;
      _this.editDcsInfo = {
        zoneIds:[],
        normalZoneIds:[],
        specialZoneIds:[],
      }
      this.updateValue(value);
    },
    // 选泽Access Zone
    checkDcsZone: function (zone) {
      let _this = this;
      let value = JSON.parse( JSON.stringify( this.value ) );
      let dcsAccessZoneIds = value.dcsAccessZoneIds;
      let index = dcsAccessZoneIds.findIndex(id => zone.id === id);
      if( index === -1 ){
        dcsAccessZoneIds.push(zone.id);
        // 自动添加endAutoZone
        this.autoAddDCSEndAutoZone(value, zone.id);
      }else{
        dcsAccessZoneIds.splice(index,1);
        // 同步删除auto zone中对应的zone
        this.autoDeleteDCSAutoZone(value, zone.id);
      }
      value.dcsAccessZoneIds = dcsAccessZoneIds;
      this.isCheckAll();
      _this.saveInfo();
    },
    // 删除Access Zone
    deleteDcsZone: async function (zone) {
      let value = JSON.parse( JSON.stringify( this.value ) );
      let dcsAccessZoneIds = value.dcsAccessZoneIds;
      let index = dcsAccessZoneIds.findIndex(id => zone.id === id);
      dcsAccessZoneIds.splice(index, 1);
      value.dcsAccessZoneIds = dcsAccessZoneIds;
      // 同步删除auto zone中对应的zone
      this.autoDeleteDCSAutoZone(value, zone.id);
      this.value.dcsAccessZoneIds = dcsAccessZoneIds;
      this.updateValue(value);
      this.isCheckAll();
      this.dcsAutoZone();
    },
    // 自动添加end auto zone
    autoAddDCSEndAutoZone(valueObj, zoneId){
      if( !valueObj.endDCSAutoZoneId ){
        valueObj.endDCSAutoZoneId = zoneId;
      }
    },
    // 自动删除已删除的Access Zone的auto zone
    autoDeleteDCSAutoZone: function(valueObj, zoneId){
      if( zoneId === valueObj.startDCSAutoZoneId ){
        this.startDCSAutoZoneId = 'all';
        valueObj.startDCSAutoZoneId = null;
      }
      if( zoneId === valueObj.endDCSAutoZoneId ){
        valueObj.endDCSAutoZoneId = null;
      }
    },
    handleDcsProfile:function(){
      let _this = this;
      _this.$parent.$parent.dCSFlag = false;
      _this.$parent.$parent.$parent.dCSFlag = false;
    },
    // 更新选择的DCS Zone
    updateValue: function(obj){
      this.$emit('input', obj);
    },
    saveInfo:function () {
      let _this = this;
      _this.value.dcsAccessZoneIds = [];
      if(_this.editDcsInfo.specialZoneIds && _this.editDcsInfo.specialZoneIds.length > 0){
        _this.value.dcsAccessZoneIds = _this.editDcsInfo.normalZoneIds.concat(_this.editDcsInfo.specialZoneIds);
      } else {
        _this.value.dcsAccessZoneIds = _this.editDcsInfo.normalZoneIds;
      }
      _this.value.dcsAccessZoneIds = _this.value.dcsAccessZoneIds.filter(val => {
        return val && val!==null && val.length > 10 ;
      })
      if(this.value.dcsAccessZoneIds && this.value.dcsAccessZoneIds.length){
        _this.$parent.$parent.dCSFlag = false;
        _this.$parent.$parent.$parent.dCSFlag = false;
      }
      this.dcsAutoZone();
    },
    // 处理dcsAutoZone里面的自动填充
    dcsAutoZone(){
      if(this.autoFill){
        let endList = this.autoEndZoneList;
        // 删除掉默认楼层和虚拟楼层剩下的都是普通楼层，这个地方需要注意的是特殊楼层也是普通楼层一样的处理方式
        let noDefault = endList.filter((item)=>{
          return !item.isDefault && !item.isVirtual 
        })
        if(noDefault.length>0){
          noDefault = noDefault.sort((a,b)=>{
            let aZone = a.name.replace(/[A-z]/g,'');
            let bZone = b.name.replace(/[A-z]/g,'');
            return Number(bZone) - Number(aZone)
          })
          let value = JSON.parse(JSON.stringify(this.value))
          // 修改的时候如果存在Auto End则不遵循自动填充规则
          // if(!this.editFlag){
          //   value.endDCSAutoZoneId = noDefault[0].id;
          // }
          value.endDCSAutoZoneId = noDefault[0].id;
          this.updateValue(value)
        }else{
          let defaultList = endList.filter((item)=>{
            return !item.isVirtual 
          })
          defaultList = defaultList.sort((a,b)=>{
            let aZone = a.name.replace(/[A-z]/g,'');
            let bZone = b.name.replace(/[A-z]/g,'');
            return Number(bZone) - Number(aZone)
          })
          let value = JSON.parse(JSON.stringify(this.value))
          value.endDCSAutoZoneId = defaultList[0]?defaultList[0].id:null;
          this.updateValue(value)
        }
      }
    },
    quickEditDcs(){
      let _this = this;
      _this.zoneList = [];
      _this.specialZoneList = [];
      this.$ajax.post('DCSZone/QueryOption', {queryNodeId : this.value.targetNodeId},{headers:{noLoading:true}}).then((res)=> {
        if (res.data.success) {
          _this.defaultZoneIds = []
          res.data.data.forEach(val => {
            if(val.isEnableSpecial) {
              if (val.isSpecial) {
                _this.specialZoneList.push(val);
              } else {
                if (val.isDefault) {
                    _this.defaultZoneIds.push(val.id);
                }
                _this.zoneList.push(val);
                  // 将默认楼层返回给上一级，用来做部门改变的判断
                let value = JSON.parse(JSON.stringify(_this.value));
                _this.$set(value,'defaultZoneIds',_this.defaultZoneIds)
                this.updateValue(value);
              }
            }else {
              _this.zoneList.push(val);
            }
          });
          _this.editDcsInfo = {
            zoneIds:JSON.parse(JSON.stringify(_this.value.dcsAccessZoneIds)),
            normalZoneIds:[],
            specialZoneIds:[],
          }
          _this.editDcsInfo.zoneIds.forEach(val => {
            let index = _this.zoneList.findIndex(sin => {
              return sin.id === val;
            })
            if(index > -1){
              _this.editDcsInfo.normalZoneIds.push(val);
            } else {
              _this.editDcsInfo.specialZoneIds.push(val);
            }
          })
          _this.defaultZoneIds.forEach(val => {
            if (_this.editDcsInfo.normalZoneIds.indexOf(val) === -1) {
              _this.editDcsInfo.normalZoneIds.push(val);
            }
          })
          _this.isCheckAll();
          _this.dcsModal = true;
        } else {
          _this.dcsModal = true;
          this.messageNotice("error",res.data.message);
        }
        this.saveInfo();
      })
    },
    isCheckAll(){
      let _this = this;
        let accessZoneIds = [];
        if(_this.editDcsInfo.normalZoneIds){
          accessZoneIds = JSON.parse( JSON.stringify(_this.editDcsInfo.normalZoneIds) )
        }
        let zoneList = _this.zoneList.filter(val => {
          return !val.isEnableSpecial;
        });
        let selZones = [];
        if( zoneList.length ){
          selZones = zoneList.filter((item)=>{
            return accessZoneIds.indexOf( item.id ) > -1;
          })
          if(selZones.length === zoneList.length){
            _this.checkAllDcs = true;
          }else{
            _this.checkAllDcs = false;
          }
        }else{
          _this.checkAllDcs = false;
        }
    },
    handleCheckAllDcs(){
      let _this = this;
      //都选上的情况，清空提示
    
      if((this.value.endDCSAutoZoneId!=null)&&_this.editDcsInfo.normalZoneIds.length==0){
        _this.$parent.dCSFlag = false;
        _this.$parent.$parent.dCSFlag = false;
        _this.$parent.$parent.$parent.dCSFlag = false;
      }

      let selZoneIds = JSON.parse(JSON.stringify(_this.editDcsInfo.normalZoneIds));
      let zoneList = _this.zoneList.filter(val => {
        return !val.isEnableSpecial;
      });
      // 全选
      if(_this.checkAllDcs){
        zoneList.forEach((item)=>{
          if( selZoneIds.indexOf( item.id ) === -1 ){
            selZoneIds.push( item.id );
          }
        })
        // 如果没有end auto zone, 选择第一个
        if( selZoneIds.length ){
          _this.editDcsInfo.endZoneId = selZoneIds[0];
        }
      }else{
        // 取消所有选择
        selZoneIds = JSON.parse(JSON.stringify(_this.defaultZoneIds));
        _this.editDcsInfo.startZoneId = "all";
        _this.editDcsInfo.endZoneId = null;
      }
      _this.$set(_this.editDcsInfo,"normalZoneIds",selZoneIds);
      _this.saveInfo();
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/dcsZoneCheck.js